const SyncBridge = ({ syncScore, isAligned }) => {
  const displayScore = syncScore !== null ? Math.round(syncScore) : 0;
  const status = displayScore >= 90 ? 'perfect' : displayScore >= 70 ? 'good' : displayScore > 0 ? 'partial' : 'waiting';

  return (
    <div className={`sync-bridge-vertical ${status}`} data-testid="sync-bridge">
      <div className="sync-line sync-line-top" />
      <div className="sync-pill">
        <span className="sync-value">{displayScore}%</span>
        <span className="sync-label">SYNC</span>
      </div>
      <div className="sync-line sync-line-bottom" />
    </div>
  );
};

export default SyncBridge;
